import { Component } from 'react';
import { Helmet } from 'react-helmet';

import Content from 'components/styled/Content/Content';
import TopBar from 'components/Header/TopBar/TopBar';
import ScrollTopOnMount from 'components/utility/ScrollTopOnMount/ScrollTopOnMount';
import BackToTop from 'components/BackToTop/BackToTop';
import Footer from 'components/Footer/Footer';
import GlossaryRoutes from 'components/Glossary/GlossaryRoutes';
import NotificationSettingsModal from 'components/notifications/Settings';

/**
 * This is the Glossary page when opening it up directly, not coming
 * from an Entity page or other page where you click on a Glossary Link.
 * If you want to open up the Glossary in a modal window, pass a state object
 * in your Router Link or Anchor component with {modal: true}
 * Also different in this page is that we show the header, something we don't do when opening up a modal window.
 */
class Glossary extends Component {
  render() {
    return (
      <>
        <ScrollTopOnMount />
        <Helmet defer={false} title="Glossary" />
        <NotificationSettingsModal />
        <TopBar />
        <Content>
          <GlossaryRoutes />
        </Content>
        <BackToTop />
        <Footer />
      </>
    );
  }
}

export default Glossary;
